import styled from 'styled-components';

import { cCC38FF } from '#/colors';

import { PRODUCT_DOCS_URL, TERMS_OF_SERVICE_URL } from '#/routes-external';

import useEffectOnce from '#/utils/useEffectOnce';

import toast from '#/components/common/toast';
import ToastTitle from '#/components/common/toast/Title';

export function BetaDisclaimerToast() {
  useEffectOnce(() => {
    toast.info(<Toast />, {
      autoClose: false,
      toastId: 'paradex-beta',
      position: 'bottom-right',
    });
  });

  return null;
}

const Toast = () => {
  return (
    <>
      <ToastTitle>Paradex Closed Beta</ToastTitle>
      This is a CLOSED BETA version of Paradex, the product is still being
      tested and can be subject to bugs and errors. For more details please read
      carefully the <TermsOfServiceLink /> & <IntroductionLink />.
    </>
  );
};

const ExternalLink = styled.a.attrs({
  rel: 'nofollow noopener',
  target: '_blank',
})`
  color: ${cCC38FF};
`;

const TermsOfServiceLink = () => (
  <ExternalLink href={TERMS_OF_SERVICE_URL}>
    Paradex terms of service
  </ExternalLink>
);

const IntroductionLink = () => (
  <ExternalLink href={`${PRODUCT_DOCS_URL}introduction/readme`}>
    documentation
  </ExternalLink>
);
